import {
  EfsMelcoEfsModelsRunListItem,
  ProductionFulfillmentApi,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useLogs = () => {
  const { setTotal } = useTable<EfsMelcoEfsModelsRunListItem>();

  const query = useAPIQuery(
    ProductionFulfillmentApi,
    ["logs"],
    async (api) => {
      const response = await api.productionFulfillmentRunsGetList();

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    setTotal,
    errorComponent,
    ...query,
  };
};
